import React from 'react';
import ReportDataPage from './ReportDataPage';

const cols = [
  { key: 'transactionId', header: 'Transaction ID' },
  { key: 'itemCount', header: 'Items' },
  { key: 'itemsPreview', header: 'Items (preview)' },
  {
    key: 'returnedAt',
    header: 'Returned',
    format: (v) => (v ? new Date(v).toLocaleString() : ''),
  },
];

const exportCols = [
  { key: 'transactionId', header: 'Transaction ID' },
  { key: 'itemCount', header: 'Item count' },
  {
    key: 'itemsJson',
    header: 'Items (JSON)',
    format: (v) => (v != null ? String(v) : ''),
  },
  {
    key: 'returnedAt',
    header: 'Returned',
    format: (v) => (v ? new Date(v).toLocaleString() : ''),
  },
];

export default function ReturnsReport() {
  return (
    <ReportDataPage
      title="Returns report"
      subtitle="Return transactions submitted from mobile (full item payload in Excel export)."
      endpoint="/api/reports/returns-records"
      exportFileSlug="returns-report"
      columns={cols}
      exportColumns={exportCols}
      emptyIcon="↩️"
    />
  );
}
